import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { getAdminConfig, updateAdminConfig, AdminConfig } from '@/api/adminConfig';

export function useAdminConfig() {
  return useQuery<AdminConfig, AxiosError<{ message?: string }>>({
    queryKey: ['admin-config'],
    queryFn: getAdminConfig,
  });
}

export function useUpdateAdminConfig() {
  const queryClient = useQueryClient();

  return useMutation<AdminConfig, AxiosError<{ message?: string }>, AdminConfig>({
    mutationFn: updateAdminConfig,
    onSuccess: (data) => {
      queryClient.setQueryData(['admin-config'], data);
      queryClient.invalidateQueries({ queryKey: ['admin-config'] });
    },
  });
}
